import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {environment} from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SigninEnabledGuard implements CanActivate  {
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return environment.signInEnabled;
  }
}
